import { useState } from 'react';
import WebApp from '@twa-dev/sdk';

interface Props {
  onBack: () => void;
}

interface FormCheckpoint {
  exercise: string;
  videoId: string;       // YouTube video ID (placeholder)
  startSec: number;
  endSec: number;
  checkpoints: string[];
}

const SAMPLE_CHECKS: FormCheckpoint[] = [
  {
    exercise: 'Sled Push',
    videoId: 'dQw4w9WgXcQ',     // placeholder, 5/15 전 실제 영상 ID
    startSec: 23,
    endSec: 48,
    checkpoints: [
      '등을 곧게 (척추 중립)',
      '무릎 발끝 따라',
      '시선 정면 5m 앞',
      '호흡 일정 (들숨 2 / 날숨 1)',
    ],
  },
  {
    exercise: 'Wall Ball',
    videoId: 'dQw4w9WgXcQ',
    startSec: 10,
    endSec: 35,
    checkpoints: [
      '풀 스쿼트 (하단 hip below knee)',
      '공 던질 때 폭발적 트리플 익스텐션',
      '시선 타깃 고정',
      '호흡 동기화 (스쿼트 ↓ 들숨 / 위 ↑ 날숨)',
    ],
  },
];

export function FormGuide({ onBack }: Props) {
  const [idx, setIdx] = useState(0);
  const [checked, setChecked] = useState<boolean[]>(SAMPLE_CHECKS[0]!.checkpoints.map(() => false));
  const current = SAMPLE_CHECKS[idx];
  if (!current) return null;

  const embedUrl = `https://www.youtube.com/embed/${current.videoId}?start=${current.startSec}&end=${current.endSec}&autoplay=0&loop=1&playlist=${current.videoId}`;

  function toggleCheck(i: number) {
    WebApp.HapticFeedback?.selectionChanged?.();
    setChecked((c) => c.map((v, j) => (j === i ? !v : v)));
  }

  function pickExercise(i: number) {
    setIdx(i);
    setChecked(SAMPLE_CHECKS[i]!.checkpoints.map(() => false));
  }

  return (
    <div className="app">
      <button className="back-link" onClick={onBack}>← 홈</button>
      <h1>🎬 폼 가이드</h1>

      <div style={{ display: 'flex', gap: 8, marginTop: 16, marginBottom: 16 }}>
        {SAMPLE_CHECKS.map((c, i) => (
          <button
            key={c.exercise}
            className={`btn ${i === idx ? '' : 'btn-secondary'}`}
            onClick={() => pickExercise(i)}
            style={{ fontSize: 13, padding: 10 }}
          >
            {c.exercise}
          </button>
        ))}
      </div>

      <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: 12, background: '#000' }}>
        <iframe
          src={embedUrl}
          title={current.exercise}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        />
      </div>
      <p style={{ fontSize: 12, color: 'var(--tg-hint)', marginTop: 8 }}>
        구간 {current.startSec}~{current.endSec}초 자동 반복
      </p>

      <h3 style={{ marginTop: 24, marginBottom: 12 }}>체크포인트 4가지</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {current.checkpoints.map((cp, i) => (
          <button
            key={i}
            className="skill-card"
            onClick={() => toggleCheck(i)}
            style={{ padding: 12, opacity: checked[i] ? 1 : 0.6 }}
          >
            <span className="icon" style={{ fontSize: 20 }}>{checked[i] ? '✅' : '⬜'}</span>
            <div className="meta">
              <h3 style={{ fontSize: 14 }}>{cp}</h3>
            </div>
          </button>
        ))}
      </div>

      <p style={{ fontSize: 13, color: 'var(--tg-hint)', marginTop: 24, textAlign: 'center' }}>
        💡 모든 체크포인트 ✅ 확인 후 다음 세트 권장
      </p>
    </div>
  );
}
